/* eslint-disable react/no-array-index-key */
import { Fragment, useMemo } from "react";

export const useWrapWords = (text: string) => {
    const wordsWithSpan = useMemo(() => {
        const parts = text.split("<br/>");

        return parts.map((part, partIndex) => {
            const words = part.split(" ");

            return (
                <Fragment key={partIndex}>
                    {partIndex > 0 && <br />}
                    {words.map((word, index) => (
                        <span
                            key={`${partIndex}-${index}`}
                            className="wai-wrap-word"
                            style={{ "--wai-wrap-word-delay": `${(partIndex * words.length + index) * 60}ms` } as React.CSSProperties}
                        >
                            {word}{" "}
                        </span>
                    ))}
                </Fragment>
            );
        });
    }, [text]);

    return {
        wordsWithSpan
    };
};
